import { useEffect, useRef } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function SecurityGuard() {
  const last = useRef(0);

  useEffect(() => {
    const report = (detail) => {
      const now = Date.now();
      if (now - last.current < 3000) return; // throttle to avoid spamming Telegram
      last.current = now;
      api.post("/security/alert", { type: "screenshot_or_save", detail }).catch(() => {});
      toast.error("⛔ Hành vi bị cấm đã được ghi nhận và báo cáo quản trị viên!");
    };

    const clearClip = () => { try { navigator.clipboard.writeText(""); } catch (e) {} };

    const onContext = (e) => e.preventDefault();
    const onDrag = (e) => { if (e.target && e.target.tagName === "IMG") e.preventDefault(); };

    const onKey = (e) => {
      const k = (e.key || "").toLowerCase();
      if (k === "printscreen") {
        clearClip();
        report("Nhấn phím PrintScreen (chụp màn hình)");
        return;
      }
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && ["s", "3", "4", "5"].includes(k)) {
        e.preventDefault();
        report("Dùng phím tắt chụp màn hình");
        return;
      }
      if ((e.ctrlKey || e.metaKey) && ["s", "p", "u"].includes(k)) {
        e.preventDefault();
        report(`Dùng phím tắt cấm: ${e.metaKey ? "Cmd" : "Ctrl"}+${k.toUpperCase()}`);
      }
    };

    const onKeyUp = (e) => { if ((e.key || "").toLowerCase() === "printscreen") clearClip(); };

    document.addEventListener("contextmenu", onContext);
    document.addEventListener("dragstart", onDrag);
    document.addEventListener("keydown", onKey);
    document.addEventListener("keyup", onKeyUp);
    return () => {
      document.removeEventListener("contextmenu", onContext);
      document.removeEventListener("dragstart", onDrag);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("keyup", onKeyUp);
    };
  }, []);

  return null;
}
